(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c1-grip-tok-customer"] && !Shopify.designMode) return;
  try {
    
(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GripTokColorways = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const SUPPLIER_REFERENCE = 'https://makerlab.ph/products/esun-pla-white-black-grey-red-green-blue-yellow-orange-filament-1-75mm-pla-plus-1kg-spool-for-3d-printer';
  // Approved filament names and pairs. Screen values are illustrative, not measured
  // eSUN swatches, stock evidence, or physical sample approval.
  const approximate = Object.freeze({ status: 'approximate', physicalMatchVerified: false,
    source: 'Illustrative screen color; physical eSUN PLA+ sample review required.', referenceUrl: SUPPLIER_REFERENCE });
  const FILAMENTS = Object.freeze([
    ['esun-matcha-green', 'Matcha Green', '#A3B875'], ['esun-soft-pink', 'Soft Pink', '#EFB6C8'],
    ['esun-purple', 'Purple', '#7954A7'], ['esun-almond-yellow', 'Almond Yellow', '#F3DEA0'],
    ['esun-light-brown', 'Light Brown', '#B58B69'], ['esun-milky-white', 'Milky White', '#F6F1E7'],
    ['esun-black', 'Black', '#202124'], ['esun-lilac', 'Lilac', '#B6A2D6'],
    ['esun-soft-blue', 'Soft Blue', '#A9CCDF'], ['esun-brown', 'Brown', '#72503E']
  ].map(([id, name, hex]) => Object.freeze({ id, name, brand: 'eSUN', material: 'PLA+',
    filamentName: 'eSUN PLA+ ' + name, hex, source: 'approved filament name; screen approximation; stock unverified', swatchEvidence: approximate })));
  // Legacy IDs retain their original names and exact preview values. They are
  // deliberately not reinterpreted as similarly named eSUN filaments.
  const LEGACY_COLORS = Object.freeze([
    ['maroon','Maroon','#762D41'],['butter','Pale yellow','#EDE894'],['blush','Light pink','#F0B8CC'],
    ['rust','Rust','#AB4D26'],['navy','Navy','#15384E'],['olive','Lime olive','#BCC967'],['lilac','Lilac','#B6A2D6'],
    ['carbon-black','Carbon black','#202124'],['warm-white','Warm white','#FFF7D6'],['window-blue','Window blue','#BFE9FF'],
    ['electric-blue','Electric blue','#4361EE'],['c1-pink','C1 pink','#FF6B9D']
  ].map(([id, name, hex], i) => Object.freeze({ id, name, hex, filamentName: name,
    source: i < 7 ? 'reference-inspired; stock unverified' : 'existing C1 palette; stock unverified',
    swatchEvidence: Object.freeze({ status: 'legacy-preview', physicalMatchVerified: false,
      source: 'Preserved existing preview value; supplier filament identity unverified.' }) })));
  const PALETTE = Object.freeze([...LEGACY_COLORS, ...FILAMENTS]);
  const COLOR_IDS = Object.freeze(PALETTE.map(color => color.id));
  const FILAMENT_BY_ID = Object.freeze(Object.fromEntries(PALETTE.map(color => [color.id, color])));
  const COLORWAYS = Object.freeze([
    ['strawberry-matcha', 'Strawberry Matcha', 'esun-matcha-green', 'esun-soft-pink'],
    ['ube-cheese', 'Ube Cheese', 'esun-purple', 'esun-almond-yellow'],
    ['iced-latte', 'Iced Latte', 'esun-light-brown', 'esun-milky-white'],
    ['cookies-cream', 'Cookies & Cream', 'esun-black', 'esun-milky-white'],
    ['matcha-latte', 'Matcha Latte', 'esun-matcha-green', 'esun-milky-white'],
    ['strawberry-milk', 'Strawberry Milk', 'esun-soft-pink', 'esun-milky-white'],
    ['ube-milk', 'Ube Milk', 'esun-lilac', 'esun-milky-white'],
    ['cotton-candy', 'Cotton Candy', 'esun-soft-blue', 'esun-soft-pink'],
    ['choco-berry', 'Choco Berry', 'esun-brown', 'esun-soft-pink'],
    ['blue-butter', 'Blue Butter', 'esun-soft-blue', 'esun-almond-yellow']
  ].map(([id, name, baseColor, textColor], index) => Object.freeze({ id, name, baseColor, textColor,
    letterColor: textColor, featured: index < 3 })));
  const CHOICES = Object.freeze(COLORWAYS.flatMap(pair => [false, true].map(swapped => {
    const baseColor = swapped ? pair.textColor : pair.baseColor;
    const textColor = swapped ? pair.baseColor : pair.textColor;
    const base = FILAMENT_BY_ID[baseColor], letters = FILAMENT_BY_ID[textColor];
    return Object.freeze({ id: pair.id + (swapped ? '-letters-first' : '-base-first'), colorwayId: pair.id,
      pairId: pair.id, name: pair.name, label: base.name + ' base / ' + letters.name + ' letters',
      baseColor, textColor, letterColor: textColor, swapped, baseHex: base.hex, letterHex: letters.hex,
      featured: pair.featured });
  })));
  function getFilament(id) { return Object.hasOwn(FILAMENT_BY_ID, id) ? FILAMENT_BY_ID[id] : null; }
  function colorName(id) { return getFilament(id)?.filamentName || null; }
  function choiceForColors(baseColor, textColor) { return CHOICES.find(choice => choice.baseColor === baseColor && choice.textColor === textColor) || null; }
  return Object.freeze({ SUPPLIER_REFERENCE, FILAMENTS, LEGACY_COLORS, PALETTE, COLOR_IDS, FILAMENT_BY_ID,
    COLORWAYS, CHOICES, getFilament, colorName, choiceForColors });
});

(function (root, factory) {
  'use strict';
  const api = factory(typeof module === 'object' && module.exports ? require('../grip-tok-colorways') : root.GripTokColorways);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.C1GripTokShopify = api;
    const boot = scope => scope.querySelectorAll('[data-grip-tok-shopify]').forEach(element => api.mount(element));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
    document.addEventListener('shopify:section:load', event => boot(event.target));
    document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-grip-tok-shopify]').forEach(element => element.gripTokAdapter?.destroy()));
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function (colorways) {
  'use strict';
  if (!colorways) throw new Error('Load Grip Tok color choices before the Shopify adapter.');
  const PROTOCOL = 'c1-grip-tok-bridge/v1';
  const KEYS = ['schema', 'engineVersion', 'fontId', 'baseDiameterMm', 'text', 'baseColor', 'textColor', 'widthMm', 'baseThicknessMm', 'letterHeightMm', 'playful'];
  const COLORS = colorways.COLOR_IDS;
  // Original and Name shape are the same Shopify design during the rename. Machine keys stay original / circle.
  // Without a Design option (the single Default Title variant) the line carries the visible property "Design" instead (fixed English, read by staff).
  // A Circle design carries one extra key, circleLayout, after the eleven shared keys (same order as the preview's normalizeCustomization).
  const CIRCLE_KEYS = Object.freeze([...KEYS, 'circleLayout']);
  const CIRCLE_LAYOUTS = Object.freeze(['auto', 'single', 'split']);
  // v2 keeps explicit rows and accents; earlier Circle snapshots remain accepted unchanged.
  const CIRCLE_FONTS = Object.freeze(['circle-bubble-v1', 'circle-dynapuff-v1', 'circle-dynapuff-v2']);
  const DESIGNS = Object.freeze({ original: 'Name shape', circle: 'Circle' });
  const designName = config => config.engineVersion === 4 ? DESIGNS.circle : DESIGNS.original;
  const displayDesignName = designName;
  const designKeyForValue = value => {
    const label = typeof value === 'string' ? value.trim().toLowerCase() : '';
    return label === 'original' || label === 'name shape' ? 'original' : label === 'circle' ? 'circle' : '';
  };
  const colorName = colorways.colorName;
  // variants: [{ id, available, design }] in product order; design is the lower-case Design option value ('' or missing without that option).
  const hasDesignOption = variants => variants.some(item => typeof item.design === 'string' && item.design !== '');
  // The variant to add for a design: without a Design option, the selected (or first) variant. With it, the selected variant when it already has
  // the design, else the first available variant with the design, else the first one with it (shown as unavailable). '' when no variant has it.
  function variantForDesign(config, variants, selectedId) {
    const selected = String(selectedId || '');
    if (!hasDesignOption(variants)) return variants.some(item => String(item.id) === selected) ? selected : String(variants[0]?.id || '');
    const want = designKeyForValue(designName(config));
    const matches = variants.filter(item => designKeyForValue(item.design) === want);
    const pick = matches.find(item => String(item.id) === selected) || matches.find(item => item.available === true) || matches[0];
    return pick ? String(pick.id) : '';
  }
  function fail(code) { return Object.assign(new Error(code), { code }); }
  function validateCustomization(value) {
    const keys = value?.engineVersion === 4 ? CIRCLE_KEYS : KEYS;
    if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).length !== keys.length || keys.some(key => !Object.hasOwn(value, key))) throw fail('DESIGN_INVALID');
    const supportedVersionPair = (value.engineVersion === 1 && value.fontId === 'modak')
      || (value.engineVersion === 2 && value.fontId === 'reference-bubble')
      || (value.engineVersion === 3 && value.fontId === 'reference-bubble-bold')
      || (value.engineVersion === 4 && CIRCLE_FONTS.includes(value.fontId));
    if (value.schema !== 'c1-grip-tok/v1' || !supportedVersionPair || value.baseDiameterMm !== 40) throw fail('DESIGN_INVALID');
    const explicitCircle = value.engineVersion === 4 && value.fontId === 'circle-dynapuff-v2';
    const unsupported = explicitCircle ? /[^A-Za-z0-9ÁÉÍÓÚÜÑáéíóúüñ .:!?'&\-\n]/ : /[^A-Za-z0-9 .:!?'&\-\n]/;
    if (typeof value.text !== 'string' || unsupported.test(value.text) || !value.text || value.text.length > 24 || (explicitCircle && value.text !== value.text.normalize('NFC'))) throw fail('DESIGN_INVALID');
    const lines = value.text.split('\n');
    if (lines.length > 2 || lines.some(line => !line || line !== line.trim().replace(/ +/g, ' '))) throw fail('DESIGN_INVALID');
    if (!COLORS.includes(value.baseColor) || !COLORS.includes(value.textColor) || typeof value.playful !== 'boolean') throw fail('DESIGN_INVALID');
    for (const [key, min, max] of [['widthMm', 32, 72], ['baseThicknessMm', 0.8, 2.4], ['letterHeightMm', 1.2, 6]]) {
      if (typeof value[key] !== 'number' || !Number.isFinite(value[key]) || value[key] < min || value[key] > max || Math.round(value[key] * 1000) / 1000 !== value[key]) throw fail('DESIGN_INVALID');
    }
    if (value.engineVersion === 4 && !CIRCLE_LAYOUTS.includes(value.circleLayout)) throw fail('DESIGN_INVALID');
    if (explicitCircle && value.circleLayout === 'single' && lines.length !== 1) throw fail('DESIGN_INVALID');
    if (explicitCircle && value.circleLayout === 'split' && value.text.replace(/\n/g, '').length < 2) throw fail('DESIGN_INVALID');
    return Object.freeze(Object.fromEntries(keys.map(key => [key, value[key]])));
  }
  class BridgeState {
    constructor(frameWindow, origin) { this.frameWindow = frameWindow; this.origin = origin; this.revision = -1; this.customization = null; }
    receive(event) {
      if (event.source !== this.frameWindow || event.origin !== this.origin) return false;
      const message = event.data;
      if (!message || message.protocol !== PROTOCOL || !['c1-grip-tok:design', 'c1-grip-tok:invalid'].includes(message.type)) return false;
      if (!Number.isSafeInteger(message.revision) || message.revision < 0 || message.revision < this.revision) return false;
      const previous = this.customization;
      const sameRevision = message.revision === this.revision;
      this.revision = message.revision; this.customization = null;
      if (message.type === 'c1-grip-tok:design') {
        try {
          const config = validateCustomization(message.customization);
          if (sameRevision && previous && JSON.stringify(config) !== JSON.stringify(previous)) return true;
          this.customization = config;
        } catch (_) { this.customization = null; }
      }
      return true;
    }
    reset() { this.revision = -1; this.customization = null; }
  }
  function resizeFrame(event, frame, origin) {
    if (event.source !== frame.contentWindow || event.origin !== origin) return false;
    const message = event.data;
    if (!message || message.protocol !== PROTOCOL || message.type !== 'c1-grip-tok:resize' ||
        !Number.isSafeInteger(message.height) || message.height < 360 || message.height > 2400) return false;
    const height = String(message.height);
    if (frame.height !== height) frame.height = height;
    return true;
  }
  function simulatorUrl(value, parentOrigin, localPreview = false) {
    const url = new URL(value);
    const parent = new URL(parentOrigin);
    const local = hostname => ['localhost', '127.0.0.1', '[::1]'].includes(hostname);
    if ((url.protocol !== 'https:' && !(localPreview && url.protocol === 'http:' && local(url.hostname) && local(parent.hostname))) || url.username || url.password || url.hash || parent.origin !== parentOrigin) throw fail('SIMULATOR_CONFIG_INVALID');
    url.searchParams.set('parentOrigin', parentOrigin);
    return url;
  }
  function createCartRequest({ customization, variantId, quantity, variants, routesRoot = '/', origin, requestId }) {
    const config = validateCustomization(customization);
    const id = String(variantId || '');
    const variant = variants.find(item => String(item.id) === id);
    if (!/^\d+$/.test(id) || !variant || variant.available !== true) throw fail('VARIANT_UNAVAILABLE');
    // Accept either name for the original design, while keeping Circle strictly separate.
    const designOption = hasDesignOption(variants);
    if (designOption && designKeyForValue(variant.design) !== designKeyForValue(designName(config))) throw fail('VARIANT_MISMATCH');
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) throw fail('QUANTITY_INVALID');
    if (typeof requestId !== 'string' || !/^[A-Za-z0-9_-]{24,128}$/.test(requestId)) throw fail('REQUEST_INVALID');
    const url = new URL(String(routesRoot) + 'cart/add.js', origin);
    if (url.origin !== origin || url.search || url.hash || !/^\/(?:[A-Za-z0-9_-]+\/)*cart\/add\.js$/.test(url.pathname)) throw fail('CART_URL_INVALID');
    // Keep line properties unchanged: Design is only a fallback when the product has no Design option.
    const choice = colorways.choiceForColors(config.baseColor, config.textColor);
    const properties = { Name: config.text, 'Base filament': colorways.colorName(config.baseColor), 'Letter filament': colorways.colorName(config.textColor) };
    if (choice) properties.Colorway = choice.name;
    if (!designOption) properties.Design = displayDesignName(config);
    Object.assign(properties, { _c1_grip_design: JSON.stringify(config), _c1_grip_schema: config.schema, _c1_grip_request: requestId });
    const body = { items: [{ id, quantity, properties }] };
    return Object.freeze({ url: url.pathname, body, customization: config, variantId: id, requestId });
  }
  async function submitCart(request, fetcher) {
    let response;
    try { response = await fetcher(request.url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(request.body) }); }
    catch (_) { throw fail('CART_UNCERTAIN'); }
    let result;
    try { result = await response.json(); } catch (_) { throw fail('CART_UNCERTAIN'); }
    if (!response.ok) throw fail(response.status >= 500 ? 'CART_UNCERTAIN' : 'CART_REJECTED');
    const line = result.items?.find(item => String(item.variant_id || item.id) === request.variantId
      && item.properties?._c1_grip_request === request.requestId && item.properties?._c1_grip_design === request.body.items[0].properties._c1_grip_design);
    if (!line) throw fail('CART_UNCERTAIN');
    return { line, customization: request.customization, variantId: request.variantId };
  }
  function mount(element) {
    if (element.gripTokAdapter) return element.gripTokAdapter;
    const win = element.ownerDocument.defaultView;
    const frame = element.querySelector('iframe'); const button = element.querySelector('[data-grip-add]');
    const form = element.querySelector('form'); const select = element.querySelector('[data-grip-variant]');
    const quantity = element.querySelector('[data-grip-quantity]'); const status = element.querySelector('[data-grip-status]');
    const price = element.querySelector('[data-grip-price]');
    if (!frame || !button || !select || !form) return null;
    let configured;
    try { configured = simulatorUrl(element.dataset.simulatorUrl, win.location.origin, element.dataset.localPreview === 'true'); }
    catch (_) { status.textContent = element.dataset.configuration; return null; }
    let busy = false, uncertain = false;
    const state = new BridgeState(frame.contentWindow, configured.origin);
    const variants = Array.from(select.options).filter(option => option.value).map(option => ({ id: option.value, available: !option.disabled }));
    const liveEnabled = element.dataset.cartEnabled === 'true';
    function update() {
      const selected = select.selectedOptions[0];
      if (price) price.textContent = selected?.dataset.price || '';
      button.disabled = busy || uncertain || !liveEnabled || !state.customization || !selected?.value || selected.disabled;
      if (!busy && !uncertain) status.textContent = !liveEnabled ? element.dataset.previewOnly : state.customization ? element.dataset.ready : element.dataset.waiting;
    }
    const receive = event => {
      if (resizeFrame(event, frame, configured.origin)) return;
      if (state.receive(event)) update();
    };
    const load = () => {
      state.reset(); update();
      frame.contentWindow.postMessage({ protocol: PROTOCOL, type: 'c1-grip-tok:request-current' }, configured.origin);
    };
    const submit = async event => {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      try {
        const request = createCartRequest({ customization: state.customization, variantId: select.value, quantity: Number(quantity.value), variants,
          routesRoot: win.Shopify?.routes?.root || '/', origin: win.location.origin, requestId: win.crypto.randomUUID().replace(/-/g, '') });
        busy = true; button.disabled = true; select.disabled = true; quantity.disabled = true; status.textContent = element.dataset.adding;
        const result = await submitCart(request, win.fetch.bind(win));
        status.textContent = element.dataset.added;
        element.dispatchEvent(new win.CustomEvent('grip-tok:cart-added', { bubbles: true, detail: result }));
      } catch (error) {
        uncertain = error.code === 'CART_UNCERTAIN';
        status.textContent = uncertain ? element.dataset.uncertain : element.dataset.rejected;
      } finally {
        busy = false; select.disabled = false; quantity.disabled = false;
        button.disabled = uncertain || !liveEnabled || !state.customization || !select.selectedOptions[0]?.value || select.selectedOptions[0]?.disabled;
      }
    };
    win.addEventListener('message', receive); frame.addEventListener('load', load); select.addEventListener('change', update); form.addEventListener('submit', submit);
    frame.src = configured.href; update();
    element.gripTokAdapter = { state, destroy() { win.removeEventListener('message', receive); frame.removeEventListener('load', load); select.removeEventListener('change', update); form.removeEventListener('submit', submit); delete element.gripTokAdapter; } };
    return element.gripTokAdapter;
  }
  return Object.freeze({ PROTOCOL, KEYS, CIRCLE_KEYS, CIRCLE_FONTS, COLORS, DESIGNS, designName, displayDesignName, designKeyForValue, colorName, hasDesignOption, variantForDesign, validateCustomization, BridgeState, resizeFrame, simulatorUrl, createCartRequest, submitCart, mount });
});

(function(){
 'use strict';
 const protocol='c1-grip-tok-bridge/v1';
 // Display names for the simulator palette ids (the child reports ids only).
 const INVALID_SETTLE_MS=450,SUBMIT_WAIT_MS=1500,MAX_QUANTITY=10;
 // frame-document:start. Same document as customer-build/frame-document.js (tests/split-bundle.test.cjs runs both on the same inputs).
 const LOCAL_HOSTS=['localhost','127.0.0.1','[::1]'];
 function escapeAttribute(value){return String(value).replace(/[&<>"'\n]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','\n':'&#10;'}[c]));}
 function storefront(origin){const parent=new URL(origin);if(parent.origin!==origin||!['https:','http:'].includes(parent.protocol))throw Error('Invalid storefront origin');if(parent.protocol==='http:'&&!LOCAL_HOSTS.includes(parent.hostname))throw Error('HTTPS storefront required');return parent;}
 function themeUrl(value,parent,pattern){
  const url=new URL(value,parent.origin);if(url.username||url.password||url.hash||!pattern.test(url.pathname))throw Error('Invalid simulator asset');if(url.origin!==parent.origin&&!(url.protocol==='https:'&&url.hostname==='cdn.shopify.com'))throw Error('Use the storefront or Shopify CDN asset');return url;
 }
 // The font stylesheet is optional: the storefront's Google Fonts css2 URL (exact origin and path, no credentials or fragment) or the theme asset c1-grip-fonts.css.
 // An unexpected URL leaves the system fallback and never blocks the preview.
 function fontLink(value,parent){
  if(!value)return '';
  try{
   const url=new URL(value,parent.origin);
   if(url.origin==='https://fonts.googleapis.com'){if(url.username||url.password||url.hash||url.pathname!=='/css2'||!url.search)return '';return '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link rel="stylesheet" href="'+escapeAttribute(url.href)+'">';}
   return '<link rel="stylesheet" href="'+escapeAttribute(themeUrl(value,parent,/\/c1-grip-fonts\.css$/).href)+'">';
  }catch(_){return '';}
 }
 // Speed: the bundle imports the Three.js and WASM chunks statically; modulepreload starts them together with the bundle instead of after it.
 // The href must be the exact URL the import resolves to (next to the bundle, without ?v=) or the chunk downloads twice; anything else is skipped.
 function preloadLinks(values,bundle,parent){
  const hrefs=[];
  for(const value of Array.isArray(values)?values.slice(0,4):[]){
   try{const chunk=themeUrl(value,parent,/\/c1-grip-(?:three|wasm|circle-font)-[a-f0-9]{12}\.js$/);chunk.search='';if(new URL('./'+chunk.pathname.split('/').pop(),bundle).href===chunk.href&&!hrefs.includes(chunk.href))hrefs.push(chunk.href);}catch(_){}
  }
  return hrefs.map(href=>'<link rel="modulepreload" href="'+escapeAttribute(href)+'">').join('');
 }
 // Posters: theme assets c1-grip-poster-phone.webp / -desktop.webp (same origin rules), plain path, optional ?v=digits only.
 function posterUrl(value,parent,kind){
  if(!value)return '';
  try{const url=themeUrl(value,parent,kind==='desktop'?/\/c1-grip-poster-desktop\.webp$/:/\/c1-grip-poster-phone\.webp$/);const query=url.search;url.search='';return /^(?:\?v=\d{1,20})?$/.test(query)&&/^https?:\/\/[A-Za-z0-9.-]+(?::\d{1,5})?\/[A-Za-z0-9._~/-]*$/.test(url.href)?url.href+query:'';}catch(_){return '';}
 }
 // ?name= from the page URL: control characters dropped, lines trimmed, at most one line break, at most 24 characters. The preview still validates it.
 function initialText(value){
  if(typeof value!=='string')return '';
  return value.replace(/%0D%0A|%0A/gi,'\n').replace(/\r\n?/g,'\n').normalize('NFC').slice(0,256);
 }
 const initialColor=value=>typeof value==='string'&&/^[a-z][a-z0-9-]{0,31}$/.test(value)?value:'';
 // ?design= from the page URL: only the exact value 'circle' is passed on; anything else opens the Original (no attribute).
 const initialDesign=value=>value==='circle'?'circle':'';
 // Share links point at the product page on the storefront origin, without query or fragment.
 function shareBase(value,parent){
  if(!value)return '';
  try{const url=new URL(value,parent.origin);if(url.origin!==parent.origin||url.username||url.password)return '';url.search='';url.hash='';return url.href;}catch(_){return '';}
 }
 // First paint before the bundle mounts: a mist plate where the 3D stage appears, with the poster in it, so the frame never shows an empty white box. The bundle replaces the body on mount.
 const FRAME_STYLE='<style>body{margin:0}.c1-grip-wait{padding:0 16px 16px}.c1-grip-wait i{position:relative;display:block;width:100%;aspect-ratio:7/5;max-height:310px;overflow:hidden;border-radius:18px;background:radial-gradient(circle 58px at 50% 50%,#EAEAE7 97%,transparent 100%),#F3F3F1}.c1-grip-wait i.c1-grip-poster{background:#F3F3F1}.c1-grip-wait img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain}@media(min-width:761px){.c1-grip-wait{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(300px,1fr);gap:28px;max-width:1232px;margin:auto;padding:0 4px 24px}.c1-grip-wait i{aspect-ratio:4/3;max-height:600px;border-radius:22px;background:radial-gradient(circle 84px at 50% 50%,#EAEAE7 97%,transparent 100%),#F3F3F1}}@media(min-width:1001px){.c1-grip-wait{grid-template-columns:minmax(0,1fr) 420px;gap:48px}}@media(prefers-reduced-motion:no-preference){.c1-grip-wait i:not(.c1-grip-poster){animation:c1-grip-wait 1.4s ease-in-out infinite alternate}@keyframes c1-grip-wait{to{opacity:.7}}}</style>';
 const FRAME_PLACEHOLDER='<div class="c1-grip-wait" aria-hidden="true"><i></i></div>';
 function framePlaceholder(phone,desktop){
  if(!phone||!desktop)return FRAME_PLACEHOLDER;
  return '<div class="c1-grip-wait" aria-hidden="true"><i class="c1-grip-poster"><picture><source media="(min-width:761px)" srcset="'+escapeAttribute(desktop)+'"><img src="'+escapeAttribute(phone)+'" alt="" fetchpriority="high"></picture></i></div>';
 }
 function frameDocument(asset,origin,options={}){
  const parent=storefront(origin);
  const url=themeUrl(asset,parent,/\/c1-grip-customer\.js$/);
  const phone=posterUrl(options.posterPhone,parent,'phone'),desktop=posterUrl(options.posterDesktop,parent,'desktop');
  const data=[['parent-origin',origin],['initial-text',initialText(options.initialText)],['initial-color',initialColor(options.initialColor)],['initial-base-color',initialColor(options.initialBaseColor)],['initial-letter-color',initialColor(options.initialLetterColor)],['initial-color-pair',options.initialColorPair===true?'true':''],['initial-design',initialDesign(options.initialDesign)],['initial-font',['circle-dynapuff-v1','circle-dynapuff-v2'].includes(options.initialFont)?options.initialFont:''],['initial-layout',['single','split','auto'].includes(options.initialLayout)?options.initialLayout:''],['gift',options.gift===true?'true':''],['share-base',shareBase(options.shareBase,parent)],['poster-phone',phone],['poster-desktop',desktop]]
   .filter(([,value])=>value).map(([name,value])=>' data-'+name+'="'+escapeAttribute(value)+'"').join('');
  // The poster is requested first: same-priority requests on one connection are served in order, and the scripts are 1.6 MB.
  const posterHints=phone&&desktop?'<link rel="preload" as="image" href="'+escapeAttribute(phone)+'" media="(max-width:760px)" fetchpriority="high"><link rel="preload" as="image" href="'+escapeAttribute(desktop)+'" media="(min-width:761px)" fetchpriority="high">':'';
  return '<!doctype html><html lang="en" data-c1-grip-customer="true"'+data+'><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><meta name="robots" content="noindex"><title>Grip Tok preview</title><link rel="icon" href="data:,">'
   +posterHints+preloadLinks(options.preloads,url,parent)+fontLink(options.fontStylesheet,parent)+FRAME_STYLE+'</head><body>'+framePlaceholder(phone,desktop)
   +'<noscript>Enable JavaScript to personalize your Grip Tok.</noscript><script type="module" src="'+escapeAttribute(url.href)+'"></script></body></html>';
 }
 // frame-document:end
 // Same shape as the storefront's own money() helper, with cents kept when a price has them.
 function money(cents){const amount=Number(cents||0)/100;const whole=Number.isInteger(amount);return '₱'+new Intl.NumberFormat('en-PH',{minimumFractionDigits:whole?0:2,maximumFractionDigits:whole?0:2}).format(amount);}
 function setText(node,text){if(node&&node.textContent!==text)node.textContent=text;}
 function mount(element){
  if(element.gripCustomerCleanup)return;
  const win=element.ownerDocument.defaultView,doc=element.ownerDocument,frame=element.querySelector('iframe'),status=element.querySelector('[data-grip-status]');
  const api=win.C1GripTokShopify;const copy=JSON.parse(element.querySelector('[data-grip-copy]').textContent);
  const state=new api.BridgeState(frame.contentWindow,win.location.origin);
  const q=selector=>element.querySelector(selector),qa=selector=>Array.from(element.querySelectorAll(selector));
  const form=q('[data-grip-customer-form]'),select=q('[data-grip-variant]'),price=q('[data-grip-price]'),error=q('[data-grip-error]');
  const line=q('[data-grip-line]'),controls=q('[data-grip-controls]'),addedPanel=q('[data-grip-added]'),summary=q('[data-grip-added-summary]');
  const qtyDisplay=q('[data-grip-qty-display]'),qtyDown=q('[data-grip-qty-down]'),qtyUp=q('[data-grip-qty-up]'),total=q('[data-grip-total]');
  const addButtons=qa('[data-grip-add]'),another=q('[data-grip-another]'),checkoutButton=q('[data-grip-checkout]'),viewCart=q('[data-grip-view-cart]');
  const headingPrice=q('.c1-grip-offer .c1-product-price span'),headingCompare=q('.c1-grip-offer .c1-product-price del'),progress=q('[data-c1-flow-progress]');
  // heard: the preview has answered since it loaded (it starts on a sample design, which counts as not ready).
  let busy=false,uncertain=false,uncertainKey=null,checkoutPending=false,heard=false,hadDesign=false,stableInvalid=false,added=null,justAdded=false,qty=1,lastIntent='cart',invalidTimer=null,settleWaiters=[],generation=0,destroyed=false;
  const liveEnabled=element.dataset.cartEnabled==='true'&&!!form;
  const options=select?Array.from(select.options).filter(o=>o.value):[];
  const variants=options.map(o=>({id:o.value,available:!o.disabled,design:o.dataset.design===undefined?'':String(o.dataset.design).trim().toLowerCase()}));
  const designOption=api.hasDesignOption(variants);
  // Back from the cart or checkout (or a reload) rebuilds the frame: the last valid design is kept per tab and product (sessionStorage) and reopened
  // when the page URL carries no shared design. Only validated designs are stored, so a sample or invalid design is never restored as orderable.
  const draftKey='c1-grip-draft:'+(element.dataset.productUrl||win.location.pathname);
  function saveDraft(config){try{win.sessionStorage.setItem(draftKey,JSON.stringify(config));}catch(_){}}
  function readDraft(){try{const raw=win.sessionStorage.getItem(draftKey);return raw?api.validateCustomization(JSON.parse(raw)):null;}catch(_){return null;}}
  // The hidden variant select follows the design in the preview (Original -> the "Original" variant, Circle -> "Circle"); it stays the form's source of truth.
  // Before a design is ready it keeps the variant Liquid selected. Returns the option to buy, or null when the design has no variant.
  function syncVariant(){
   if(!select)return null;
   if(!designOption||!state.customization)return select.selectedOptions[0]||null;
   const id=api.variantForDesign(state.customization,variants,select.value);
   const option=options.find(o=>o.value===id)||null;
   if(option&&select.value!==id)select.value=id;
   return option;
  }
  // Nothing to buy: no variant at all, or (before a design is ready, with Design variants) no available Original or Circle variant.
  function isUnavailable(option){
   if(designOption&&!state.customization)return !variants.some(v=>v.available&&api.designKeyForValue(v.design));
   return !option?.value||option.disabled;
  }
  const designKey=config=>JSON.stringify(config);
  // One cart line per design (and its variant): changing the design after an add is a new item.
  const itemKey=(config,variantId)=>designKey(config)+'|'+variantId;
  const currentKey=()=>state.customization?itemKey(state.customization,syncVariant()?.value||''):null;
  // Designs added in this page view: adding one again after "Edit or add another" means one more, not a retry.
  const confirmed=new Set();
  // Bar and added summaries name the design only when it is not the Original: "MIA · Navy · Circle".
  const describe=config=>config.text.split('\n').join(' / ')+' · '+api.colorName(config.baseColor).replace(/^eSUN PLA\+ /,'')+' base / '+api.colorName(config.textColor).replace(/^eSUN PLA\+ /,'')+' letters'+' · '+api.displayDesignName(config);
  function showError(message){if(!error)return;error.textContent=message;error.hidden=false;}
  function fieldEmpty(){try{const field=frame.contentDocument?.getElementById('design-text');return !field||!field.value.trim();}catch(_){return true;}}
  function hideError(){if(error){error.hidden=true;error.textContent='';}}
  // Buying-flow progress in the pinned bar, on the 0-100 scale of snippets/c1-flow-progress.liquid (c1-line.js runs the cart and Delivery
  // details): 10 with the default style and colors, 34 once the name makes a valid design, 50 while that design is in the cart.
  function setProgress(value){
   if(!progress||progress.getAttribute('aria-valuenow')===String(value))return;
   progress.setAttribute('aria-valuenow',String(value));progress.style.setProperty('--c1-flow-progress',String(value/100));
  }
  function update(){
   const ready=!!state.customization;
   element.dataset.designReady=String(ready);
   const selected=syncVariant();
   const unavailable=isUnavailable(selected);
   const cents=Number(selected?.dataset.priceCents||0);
   setText(price,selected?.dataset.price||'');
   setText(total,money(cents*qty));
   // The heading price follows the variant too (desktop shows it; both designs are the same price today).
   if(selected?.dataset.price){setText(headingPrice,selected.dataset.price);if(headingCompare){const compare=selected.dataset.comparePrice||'';setText(headingCompare,compare);headingCompare.hidden=!compare;}}
   setText(qtyDisplay,String(qty));
   if(qtyDown)qtyDown.disabled=busy||qty<=1;
   if(qtyUp)qtyUp.disabled=busy||qty>=MAX_QUANTITY;
   const key=ready?itemKey(state.customization,selected?.value||''):null;
   // A new valid design after an add is a new item: arm the buttons again (but always show the confirmation once).
   if(added&&ready&&!justAdded&&key!==added.key)added=null;
   justAdded=false;
   // A new design after an unconfirmed add gets a fresh try.
   if(uncertain&&ready&&key!==uncertainKey){uncertain=false;uncertainKey=null;hideError();}
   if(controls)controls.hidden=!!added;
   if(addedPanel)addedPanel.hidden=!added;
   if(viewCart)viewCart.hidden=!(added||uncertain);
   const blocked=busy||uncertain||checkoutPending||!liveEnabled||unavailable||!hadDesign||(!ready&&stableInvalid);
   addButtons.forEach(button=>{button.disabled=blocked;});
   if(checkoutButton)checkoutButton.disabled=busy||checkoutPending;
   if(another)another.disabled=busy||checkoutPending;
   // Bar priority: loading -> name (sample or invalid design) -> all set. The grip fits any phone, so there is no phone step.
   if(line){
    let text=null,mode='blocked';
    if(!heard){text=copy.loading;mode='loading';}
    else if(unavailable)text=copy.variant_unavailable;
    else if(busy)text=copy.adding;
    else if(uncertain)text=copy.qty;
    else if(ready){text=copy.all_set+' · '+describe(state.customization);mode='true';}
    else if(stableInvalid){text=fieldEmpty()?copy.next_name:copy.waiting;mode='false';}
    // A design that is only invalid for a moment (the preview is rebuilding) keeps the previous line.
    if(text!==null){setText(line,text);line.dataset.ready=mode;line.setAttribute('aria-disabled',String(mode!=='false'));}
   }
   if(!busy&&!uncertain&&!added&&(ready||stableInvalid||!heard))setText(status,!heard?copy.loading:!ready?(fieldEmpty()?copy.next_name:copy.waiting):liveEnabled?copy.ready:copy.review);
   // Like the line, a design that is invalid only for a moment (the preview is rebuilding) keeps the fill.
   if(added)setProgress(50);else if(ready)setProgress(34);else if(!heard||stableInvalid)setProgress(10);
  }
  const settle=ms=>new Promise(resolve=>{
   if(state.customization)return resolve(true);
   const done=ok=>{win.clearTimeout(timer);resolve(ok!==false);};
   const timer=win.setTimeout(()=>{settleWaiters=settleWaiters.filter(fn=>fn!==done);resolve(false);},ms);
   settleWaiters.push(done);
  });
  // Bridge messages from the preview: resize, and design / invalid (BridgeState). Nothing else is read.
  const receive=event=>{
   if(api.resizeFrame(event,frame,win.location.origin))return;
   if(!state.receive(event))return;
   heard=true;
   if(state.customization){
    hadDesign=true;stableInvalid=false;saveDraft(state.customization);
    if(invalidTimer){win.clearTimeout(invalidTimer);invalidTimer=null;}
    settleWaiters.splice(0).forEach(fn=>fn());
   }else{
    // Every keystroke invalidates; only a quiet 450 ms counts as a stable invalid design.
    if(invalidTimer)win.clearTimeout(invalidTimer);
    invalidTimer=win.setTimeout(()=>{invalidTimer=null;stableInvalid=true;update();},INVALID_SETTLE_MS);
   }
   update();
  };
  const load=()=>{
   state.reset();heard=false;hadDesign=false;stableInvalid=false;
   if(invalidTimer){win.clearTimeout(invalidTimer);invalidTimer=null;}
   update();
   frame.contentWindow.postMessage({protocol,type:'c1-grip-tok:request-current'},win.location.origin);
  };
  const bar=q('.c1-grip-buy');
  // Puts the name field below enough room for the simulator's slim typing preview, above the fixed bar.
  function scrollToField(field){
   const frameRect=frame.getBoundingClientRect(),fieldRect=field?field.getBoundingClientRect():{top:0,height:0};
   const barHeight=bar&&win.getComputedStyle(bar).position==='fixed'?bar.getBoundingClientRect().height:0;
   const room=Math.max(96,Math.min(280,win.innerHeight-barHeight-fieldRect.height-24));
   const html=doc.documentElement,behavior=html.style.scrollBehavior;
   html.style.scrollBehavior='auto';
   win.scrollTo(0,Math.max(0,frameRect.top+fieldRect.top+win.scrollY-room));
   html.style.scrollBehavior=behavior;
  }
  function focusDesign(){
   let field=null;
   try{field=frame.contentDocument?.getElementById('design-text')||null;}catch(_){field=null;}
   try{if(field)field.focus({preventScroll:true});}catch(_){}
   scrollToField(field);
   // The simulator switches to its slim typing layout on focus (sometimes a tick later); settle the scroll once more.
   win.setTimeout(()=>{try{if(field&&frame.contentDocument?.activeElement===field)scrollToField(field);}catch(_){}},320);
  }
  function goToCheckout(){
   if(checkoutPending)return;
   checkoutPending=true;update();
   if(!win.C1Delivery){showError('Delivery details could not load. Please refresh the page.');checkoutPending=false;update();return;}
   win.C1Delivery.open({checkoutURL:new URL(String(win.Shopify?.routes?.root||'/')+'checkout',win.location.origin).href})
    .catch(()=>showError('Delivery details could not load. Please refresh the page.'))
    .finally(()=>{checkoutPending=false;update();});
  }
  // One cart line per design and variant: Buy now or Add for a design that is already in the cart (after Back, a reload or an unconfirmed add)
  // reuses that line instead of adding a duplicate line (every add has its own _c1_grip_request). Distinct designs stay separate lines.
  // The page quantity starts at 1 again after Back, so a reused line is never lowered; 'again' (the same design was already added in this page
  // view, then "Edit or add another") adds the page quantity to the line.
  async function upsertCart(request,again){
   const root=String(win.Shopify?.routes?.root||'/'),item=request.body.items[0];
   const fail=code=>Object.assign(new Error(code),{code});
   const call=async(path,body)=>{
    let response,result;
    try{response=await win.fetch(root+path,body?{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}:{credentials:'same-origin',headers:{Accept:'application/json'}});result=await response.json();}
    catch(_){throw fail('CART_UNCERTAIN');}
    if(!response.ok)throw fail(response.status>=500?'CART_UNCERTAIN':'CART_REJECTED');
    return result;
   };
   const same=line=>String(line.variant_id)===request.variantId&&line.properties?._c1_grip_design===item.properties._c1_grip_design;
   const existing=(await call('cart.js')).items?.find(same);
   if(!existing)return api.submitCart(request,win.fetch.bind(win));
   const quantity=again?existing.quantity+item.quantity:Math.max(existing.quantity,item.quantity);
   if(quantity===existing.quantity)return {line:existing,customization:request.customization,variantId:request.variantId};
   const line=(await call('cart/change.js',{id:existing.key,quantity})).items?.find(entry=>entry.key===existing.key&&same(entry));
   if(!line||line.quantity!==quantity)throw fail('CART_UNCERTAIN');
   return {line,customization:request.customization,variantId:request.variantId};
  }
  const submit=async event=>{
   event.preventDefault();
   const intent=event.submitter?.dataset.gripIntent||lastIntent;
   if(busy||uncertain||checkoutPending||added||!liveEnabled)return;
   const myGeneration=generation;
   const stale=()=>destroyed||myGeneration!==generation;
   if(!state.customization&&!(await settle(SUBMIT_WAIT_MS))){if(stale())return;stableInvalid=true;update();focusDesign();return;}
   if(stale()||busy||uncertain||checkoutPending||added)return;
   // The variant of the design on screen (Original / Circle); unavailable shows in the bar instead of adding the other design's variant.
   const variant=syncVariant();
   if(isUnavailable(variant)){update();return;}
   if(!form.reportValidity())return;
   let request;
   try{request=api.createCartRequest({customization:state.customization,variantId:variant.value,quantity:qty,variants,routesRoot:win.Shopify?.routes?.root||'/',origin:win.location.origin,requestId:win.crypto.randomUUID().replace(/-/g,'')});}
   catch(_){showError(copy.rejected);setText(status,copy.rejected);return;}
   busy=true;hideError();if(select)select.disabled=true;update();setText(status,copy.adding);
   try{
    const result=await upsertCart(request,confirmed.has(itemKey(request.customization,request.variantId)));
    if(destroyed)return;
    element.dispatchEvent(new win.CustomEvent('grip-tok:cart-added',{bubbles:true,detail:result}));
    // Restored from the back-forward cache meanwhile: the line is in the cart, but do not navigate or repaint over the restored page.
    if(myGeneration!==generation)return;
    added={key:itemKey(result.customization,result.variantId),quantity:result.line.quantity};justAdded=true;confirmed.add(added.key);
    busy=false;if(select)select.disabled=false;
    // The shopper may have changed the name or design while the request ran: confirm what was added, and only go straight to checkout when it is still the design on screen.
    const drifted=currentKey()!==added.key;
    setText(summary,added.quantity+' × '+copy.title+' · '+describe(result.customization));
    setText(status,copy.added);update();
    if(intent==='checkout'&&!drifted)goToCheckout();
   }catch(err){
    if(stale())return;
    busy=false;if(select)select.disabled=false;
    uncertain=err.code==='CART_UNCERTAIN';uncertainKey=uncertain?itemKey(request.customization,request.variantId):null;
    const message=uncertain?copy.uncertain:copy.rejected;
    showError(message);setText(status,message);update();
   }
  };
  const onIntent=event=>{lastIntent=event.currentTarget.dataset.gripIntent||'cart';};
  const onLine=()=>{if(line.dataset.ready!=='false')return;focusDesign();};
  const onDown=()=>{qty=Math.max(1,qty-1);update();};
  const onUp=()=>{qty=Math.min(MAX_QUANTITY,qty+1);update();};
  const onAnother=()=>{if(busy||checkoutPending)return;added=null;hideError();update();};
  const onCheckout=()=>{if(!added||busy||checkoutPending)return;goToCheckout();};
  const onPageShow=event=>{if(!event.persisted)return;generation+=1;checkoutPending=false;busy=false;if(select)select.disabled=false;update();};
  win.addEventListener('message',receive);win.addEventListener('pageshow',onPageShow);frame.addEventListener('load',load);form?.addEventListener('submit',submit);select?.addEventListener('change',update);
  addButtons.forEach(button=>button.addEventListener('click',onIntent));
  line?.addEventListener('click',onLine);qtyDown?.addEventListener('click',onDown);qtyUp?.addEventListener('click',onUp);another?.addEventListener('click',onAnother);checkoutButton?.addEventListener('click',onCheckout);
  // A ?variant= link to the Circle variant (e.g. the product link of a cart line) opens the Circle design when there is no ?design=.
  function variantDesign(params){
   const id=params.get('variant');
   return id&&variants.some(v=>v.id===id&&v.design==='circle')?'circle':'';
  }
  // Frame options: ?name= / ?color= / ?design= (or ?variant=) from the page URL (shared designs), the gift setting, the share link base, posters and chunk preloads (validated in frameDocument).
  function frameOptions(){
   const params=new URLSearchParams(win.location.search),color=params.get('color');
   let share='';try{share=new URL(element.dataset.productUrl||win.location.pathname,win.location.origin).href;}catch(_){share='';}
   const common={fontStylesheet:element.dataset.fontCss,gift:element.dataset.gift==='true',shareBase:share,
    posterPhone:element.dataset.posterPhone,posterDesktop:element.dataset.posterDesktop,preloads:String(element.dataset.preload||'').split(/\s+/).filter(Boolean)};
   // A shared design in the URL wins over the stored draft; so does a cart line link (?variant=) to the other design.
   const shared=['name','color','baseColor','letterColor','design','font','layout'].some(key=>params.has(key));
   const draft=shared?null:readDraft(),linked=variants.find(v=>v.id===params.get('variant'));
   if(draft&&!(linked?.design&&api.designKeyForValue(linked.design)!==api.designKeyForValue(api.designName(draft)))){
    const circle=draft.engineVersion===4;
    return {...common,initialText:draft.text,initialColor:'',initialBaseColor:draft.baseColor,initialLetterColor:draft.textColor,initialColorPair:true,initialDesign:circle?'circle':'',initialFont:circle?draft.fontId:'',initialLayout:circle?draft.circleLayout:''};
   }
   return {...common,initialText:params.get('name')||'',initialColor:api.COLORS.includes(color)?color:'',initialBaseColor:params.get('baseColor')||'',initialLetterColor:params.get('letterColor')||'',initialColorPair:params.has('baseColor')||params.has('letterColor'),initialDesign:params.get('design')||variantDesign(params),initialFont:params.get('font')||'',initialLayout:params.get('layout')||''};
  }
  try{frame.srcdoc=frameDocument(element.dataset.assetUrl,win.location.origin,frameOptions());update();}catch(_){setText(status,copy.unavailable);showError(copy.unavailable);}
  element.gripCustomerCleanup=()=>{
   win.removeEventListener('message',receive);win.removeEventListener('pageshow',onPageShow);frame.removeEventListener('load',load);form?.removeEventListener('submit',submit);select?.removeEventListener('change',update);
   addButtons.forEach(button=>button.removeEventListener('click',onIntent));
   line?.removeEventListener('click',onLine);qtyDown?.removeEventListener('click',onDown);qtyUp?.removeEventListener('click',onUp);another?.removeEventListener('click',onAnother);checkoutButton?.removeEventListener('click',onCheckout);
   destroyed=true;if(invalidTimer)win.clearTimeout(invalidTimer);settleWaiters.splice(0).forEach(fn=>fn(false));
   delete element.gripCustomerCleanup;
  };
 }
 function boot(scope){scope.querySelectorAll('[data-grip-customer-section]').forEach(mount);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);
 document.addEventListener('shopify:section:load',event=>boot(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-grip-customer-section]').forEach(el=>el.gripCustomerCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c1-line-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('c1:product-change', event => {
    const productId = String(event.detail?.productId ?? '');
    if (!/^\d+$/.test(productId)) return;
    document.querySelectorAll('[data-c1-reviews][data-review-page="product"]').forEach(section => {
      let visible = false;
      section.querySelectorAll('[data-review-product-id]').forEach(card => {
        const matches = card.dataset.reviewProductId === productId;
        card.hidden = !matches;
        visible = visible || matches;
      });
      section.dataset.currentProductId = productId;
      section.hidden = !visible;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
